"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var rxjs_1 = require("rxjs");
var subjects = new WeakMap();
function ObservableInput() {
    return function (target, propertyKey) {
        delete target[propertyKey];
        Object.defineProperty(target, propertyKey, {
            set: function (value) {
                this[propertyKey].next(value);
            },
            get: function () {
                var subjectByProp = subjects.get(this) || new Map();
                var subject = subjectByProp.get(propertyKey);
                if (!subject) {
                    subject = new rxjs_1.ReplaySubject(1);
                    subjectByProp.set(propertyKey, subject);
                    subjects.set(this, subjectByProp);
                }
                return subject;
            },
        });
    };
}
exports.ObservableInput = ObservableInput;
//# sourceMappingURL=index.js.map